const state = () => ({
  creditInfo: null
})

const mutations = {
  SET_CREDIT_INFO (state, payload) {
    state.creditInfo = payload
  },
  RESET_CREDIT_INFO (state) {
    state.creditInfo = null
  }
}

const actions = {
  setCreditInfo ({ commit }, payload) {
    commit('SET_CREDIT_INFO', payload)
  },
  resetCredit ({ commit }) {
    commit('RESET_CREDIT_INFO')
  }
}

const getters = {
  creditInfo: (state) => state.creditInfo,
  creditAmount: (state) => state.creditInfo?.credit ?? 0,
  creditPackage: (state) => state.creditInfo?.package_name ?? ''
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
